import { WSAlert, WSList, WSText } from "@wingspanhq/fe-component-library";
import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";

import { selectorInsuranceCoverageWarnings } from "../helpers/insuranceWarnings";

type Props = {
  coverage: insuranceCoverageApiSpec.InsuranceCoverage | undefined;
};

/**
 * The non-blocking checks a coverage carries from its certificate import, as
 * one "Warnings" box listing each check's message. The both-names narration
 * stays on the upload flow, where the contractor decides what to do with the
 * certificate; here the reader already has the policy in front of them.
 */
export const InsuranceCoverageWarnings: React.FC<Props> = ({ coverage }) => {
  const warnings = selectorInsuranceCoverageWarnings(coverage);

  if (warnings.length === 0) {
    return null;
  }

  return (
    <WSAlert icon="alert" theme="warning" title="Warnings">
      <WSList gap="XS">
        {warnings.map((warning, index) => (
          <WSText.ParagraphSm key={`${warning.title}-${index}`}>
            {`\u2022 ${warning.message}`}
          </WSText.ParagraphSm>
        ))}
      </WSList>
    </WSAlert>
  );
};
